// Utility functions
export function rollDie(sides) {
  return Math.floor(Math.random() * sides) + 1;
}

export function rollDice(num, sides, dropLowest = false) {
  const rolls = [];
  for (let i = 0; i < num; i++) {
    rolls.push(rollDie(sides));
  }
  if (dropLowest) {
    rolls.sort((a, b) => a - b);
    rolls.shift();
  }
  return rolls.reduce((sum, roll) => sum + roll, 0);
}